export const getParticipationsStatuses = (participations) => {
    const singlePositions = participations.filter((row) => row.columns.positions.length === 1);
    const denied = participations.filter((row) => ['deniedRosterFull', 'deniedNotQualified'].includes(row.columns.status)).length;
    const oigFailed = participations.filter((row) => row.columns.accountOigStatus === 'notVerified').length;
    const multiplePositions = participations.length - singlePositions.length;
    return {
        oigFailed,
        denied,
        multiplePositions,
    };
};
